<template>
  <div class="p-4">
    <h1 class="text-white text-lg">لیست غذاها</h1>
    <ReceiptProductCard
      v-for="product in products"
      :key="product.kala"
      :product="product"
    />

    <div
      class="flex justify-between bg-gray-900 rounded-2xl p-4 mt-3 text-white"
    >
      <span>
        جمع کل
        <span class="text-xs">(با مالیات)</span>
        :
      </span>
      <span class="text-green-500">{{
        $helper.priceFormatter(totalPrice)
      }}</span>
    </div>

    <!-- <div
      class="flex justify-between bg-gray-900 rounded-2xl p-4 mt-3 text-white"
      v-if="$store.state.factor.discount"
    >
      <span>تخفیف: </span>
      <span class="text-green-500">{{
        $helper.priceFormatter($store.state.factor.discount)
      }}</span>
    </div> -->

    <div
      class="flex justify-between bg-gray-900 rounded-2xl p-4 mt-3 text-white"
      v-if="$store.state.factor.discount"
    >
      <span>مبلغ قابل پرداخت: </span>
      <span class="text-green-500">{{
        $helper.priceFormatter(totalPrice - $store.state.factor.discount)
      }}</span>
    </div>

    <h1 class="text-white text-lg mt-4">نحوه پرداخت</h1>
    <div class="flex items-center mt-2 text-white">
      <div
        class="border-2 border-gray-500 rounded-lg p-3 text-xs"
        :class="{ '!border-yellow-500': this.paymentType === 'online' }"
        @click="this.paymentType = 'online'"
      >
        <DesktopComputerIcon class="mb-1 h-5 w-5 mx-auto" />
        آنلاین
      </div>
      <div
        class="border-2 border-gray-500 rounded-lg p-3 text-xs mr-4"
        :class="{ '!border-yellow-500': this.paymentType === 'pos' }"
        @click="this.paymentType = 'pos'"
      >
        <CreditCardIcon class="mb-1 h-5 w-5 mx-auto" />
        کارتخوان
      </div>
      <div
        class="border-2 border-gray-500 rounded-lg p-3 text-xs mr-4"
        :class="{ '!border-yellow-500': this.paymentType === 'register' }"
        @click="this.paymentType = 'register'"
      >
        <CashIcon class="mb-1 h-5 w-5 mx-auto" />
        صندوق
      </div>
    </div>
    <div v-if="this.paymentType === 'pos'" class="flex flex-row mt-2">
      <Input
        type="text"
        class="basis-1/2 mt-4"
        placeholder="کدرهگیری"
        required
        v-model="cartTracking"
      />
      <select
        v-model="numberpos"
        class="rounded-xl w-full basis-1/2 h-10 mt-4 mr-1"
        required
      >
        <option value="">شماره pos</option>
        <option value="1">1</option>
        <option value="2">2</option>
        <option value="3">3</option>
        <option value="4">4</option>
      </select>
    </div>

    <h1 class="text-white text-lg mt-4">جزئیات</h1>
    <Input
      type="number"
      class="mt-2"
      placeholder="تاخیر تحویل"
      v-model="deliveryDelay"
    />
    <textarea
      class="rounded-xl p-2 w-full mt-3"
      placeholder="توضیحات"
      v-model="description"
    ></textarea>

    <Button class="mt-1" @click="submit">ثبت</Button>
  </div>
</template>

<script>
import ReceiptProductCard from "@/views/ReceiptProductCard";
import Input from "@/components/Input";
import { postFactor, updateFactor, } from "@/API/API";
import { mapGetters } from "vuex";
import Button from "@/components/General/Button";
import {
  CashIcon,
  CreditCardIcon,
  DesktopComputerIcon,
} from "@heroicons/vue/outline";

export default {
  name: "Receipt",
  components: {
    Button,
    Input,
    ReceiptProductCard,
    CreditCardIcon,
    CashIcon,
    DesktopComputerIcon,
  },
  data() {
    return {
      deliveryDelay: this.$store.state.factor.deliveryDelay,
      description: this.$store.state.factor.description,
      paymentType: "online",
      cartTracking: "",
      numberpos: "",
      inputvalue: "",
      issave: false,
      factorSum:{}
    };
  },
  async created() {
    console.log(this.$store.state.cart.newFactor.newP.goods)
   
  },
  computed: {
    products() {
      return this.$store.state.cart.newFactor.newP.hsale.goods;
      
    },
    totalPrice() {
      return this.$store.state.cart.newFactor.newP.factorSum.paymentAfterTax;
      // return this.products.reduce(
      //   (totalPrice, product) =>
      //     (totalPrice +=
      //       product.nerkh_With_Maliat * product.isNegative * product.quantity),
      //   0
      // );
    },
    ...mapGetters(["editFactor"]),
  },
  methods: {
    submit() {
      let deliveryDelay = this.deliveryDelay;
      let description = this.description;
      let paymentType = this.paymentType;
      this.inputvalue = this.cartTracking.replace(/[۰-۹]/g, (value) =>
        "۰۱۲۳۴۵۶۷۸۹".indexOf(value)
      );
      let cartTrackingNo = this.inputvalue;
      let PosNo = this.numberpos;
      if (this.paymentType === "pos" && PosNo == "") {
        this.$swal({
          icon: "error",
          title: "خطا",
          text: "شماره پز را انتخاب کنید",
          confirmButtonColor: "#fcd34d",
          confirmButtonText: "باشه",
        });
      } else if (this.paymentType === "pos" && PosNo != "") {
        PosNo = parseInt(this.numberpos);
        this.$store.dispatch("setFactorDetail", {
          description,
          deliveryDelay,
          paymentType,
          cartTrackingNo,
          PosNo,
        });
        this.postFactor();
      } else {
        this.$store.dispatch("setFactorDetail", {
          description,
          deliveryDelay,
          paymentType,
          cartTrackingNo,
          PosNo,
        });
        this.postFactor();
      }
    },
    postFactor() {
      this.loading = true;
      if (this.editFactor) {
        this.updateFactor();
      } else {
        this.createFactor();
      }
    },
    updateFactor() {
      let factor = this.$store.state.factor;
      factor.goods = this.$store.state.cart.products;
      updateFactor(factor)
        .then((resp) => this.onFactorSuccess(resp))
        .catch((err) => {
          if (err.response.data.statusCode == 426) {
            this.$swal({
              icon: "warning",
              title: "جایزه",
              text: err.response.data.result[0].col,
              confirmButtonColor: "#088b24",
              confirmButtonText: "بلی",
              showDenyButton: true,
              denyButtonColor: "#EF4444",
              denyButtonText: "لغو",
            }).then((result) => {
              if (result.isConfirmed) {
                this.$router.replace("/submit-order/menu");
              } else if (result.isDenied) {
                this.issave = true;
                updateFactor(factor, this.issave)
                  .then((resp) => {
                    this.onFactorSuccess(resp);
                  })
                  .catch((err) => this.onFactorError(err));
              }
            });
          } else {
            this.onFactorError(err);
          }
        })
        .finally(() => (this.loading = false));
    },
    createFactor() {
      let factor = this.$store.state.factor;
      factor.goods = this.$store.state.cart.products;
      postFactor(factor, this.issave)
        .then((resp) => this.onFactorSuccess(resp))
        .catch((err) => {
          if (err.response.data.statusCode == 426) {
            this.$swal({
              icon: "warning",
              title: "جایزه",
              text: err.response.data.result[0].col,
              confirmButtonColor: "#088b24",
              confirmButtonText: "بلی",
              showDenyButton: true,
              denyButtonColor: "#EF4444",
              denyButtonText: "لغو",
            }).then((result) => {
              if (result.isConfirmed) {
                this.$router.replace("/submit-order/menu");
              } else if (result.isDenied) {
                this.issave = true;
                postFactor(factor, this.issave)
                  .then((resp) => {
                    this.onFactorSuccess(resp);
                  })
                  .catch((err) => this.onFactorError(err));
              }
            });
          } else {
            this.onFactorError(err);
          }
        })
        .finally(() => (this.loading = false));
    },
    onFactorSuccess(resp) {
      this.$store.dispatch("emptyCart");
      this.$swal({
        icon: "success",
        title: "موفق",
        text: resp.data.message,
        confirmButtonColor: "#fcd34d",
        confirmButtonText: "باشه",
      }).then(() => {
        this.$store.dispatch("emptyCart");
        this.$router.replace("/menu");
      });
    },
    onFactorError(err) {
      let unorderedList = document.createElement("ul");
      unorderedList.classList.add("text-sm", "text-right", "list-disc");

      err.response.data.result.forEach((error) => {
        let li = document.createElement("li");
        li.innerText = error.col;
        unorderedList.appendChild(li);
      });

      this.$swal({
        icon: "error",
        title: "خطا",
        html: unorderedList,
        confirmButtonColor: "#fcd34d",
        confirmButtonText: "باشه",
      });
    },
  },
};
</script>
